import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  scroll-snap-align: start;
`;
export const Content = styled.div`
  width: 33.33%;
  height: 100vh;
  overflow-y: hidden;
  &.left {
    background-color: #333333;
  }

  &.right {
    background-color: #777777;
  }
`;
export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
  --webkit-overflow-scrolling: touch;

  &.unsetScrollBehavior {
    scroll-behavior: unset;
  }
`;

interface ImageProsp {
  url: string;
}
export const Image = styled.div<ImageProsp>`
  width: 100%;
  height: 100vh;
  scroll-snap-align: start;
  background: ${({ url }) => url && `url(${url}) no-repeat center center`};
  background-size: cover;
`;
